module.exports = __webpack_public_path__ + "static/media/icon_book.fec32652.svg";